import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { TranslateHelper } from '../../../../helpers/injector.helper';
import { TaskRegistryEntry, TaskType } from '../../../../helpers/task.registry';
import { ConditionalLevelTaskExecuter } from '../../../../models/tasks/formattasks/conditionallevel.formatting.task';
import { TaskHelper } from '../../../../models/tasks/task.helper';
import { MultiReportingService } from '../../../../services/reporting.service';
import { ALevelMeasureTaskSettingsHelper } from '../../a.task.panel';
import { AConditionalFormattingTaskPanel } from './aconditional.formatting.task.panel';

@Component({
    selector: 'level-conditional-formatting-task-panel',
    templateUrl: './conditional.formatting.task.panel.html'
})
export class LevelConditionalFormattingTaskPanel extends AConditionalFormattingTaskPanel {

    StyleVal = {};
   
    static GetRegistry(): TaskRegistryEntry {
        const reg = new TaskRegistryEntry();
        reg.ID = ConditionalLevelTaskExecuter.TaskID;
        reg.Caption = '@@Bedingte Levelformatierung';
        reg.SettingsControl = LevelConditionalFormattingTaskPanel;
        reg.SettingsHelper = new LevelConditionalTaskSettingsHelper();
        reg.Executer = ConditionalLevelTaskExecuter;
        reg.TaskType = TaskType.FormatTask;
        return reg;
    }

    constructor(public service: MultiReportingService, public cdRef: ChangeDetectorRef) {
        super(service, cdRef);
    }

    TaskTypeIDValue = ConditionalLevelTaskExecuter.TaskID;
    @Input()
    get TaskTypeID() {
        return this.TaskTypeIDValue;
    }
    set TaskTypeID(val) {
        this.TaskTypeIDValue = val;
    }
}

export class LevelConditionalTaskSettingsHelper extends ALevelMeasureTaskSettingsHelper {
    canExecute(reportObject: any): boolean {
        return TaskHelper.IsTableObject(reportObject);
    }
    getCaption(task: any, dd: any) {
        let caption = super.getCaption(task, dd);
        if (caption) {
            caption += '-' + TranslateHelper.TranslatorInstance.instant('@@Bedingt');
            return caption;
        }
        return TranslateHelper.TranslatorInstance.instant('@@Bedingte Levelformatierung');
    }
}
